import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import { isEmpty } from 'utils/types';
import { selectors as errorsSelectors } from 'state/errors';
import { selectors as settingsSelectors } from 'state/settings';
import {
  actions as orderActions,
  selectors as orderSelectors,
  selectorsByType,
} from 'state/order';
import {
  getExtras,
  getPriceConcepts,
  getRecurringPriceConcepts,
} from 'utils/order';

import QuotePriceStyled from 'components/Price/styled';
import { withTranslation } from 'react-i18next';

const enhanceWithQuote = compose(
  withTranslation('Quote'),
  connect(
    (state, { typeOfOrder }) => {
      const orderType = typeOfOrder || orderSelectors.getTypeOfOrder(state);

      return {
        currencySymbol: settingsSelectors.getCurrency(state).symbol,
        isFetching: selectorsByType.ui[orderType].getIsFetching(state),
        isSubmitting: selectorsByType.ui[orderType].getIsSubmitting(state),
        isEditing: orderSelectors.getIsEditing(state),
        error: selectorsByType.quote[orderType].getQuoteError(state),
        errors: errorsSelectors.getErrors(state),
        quote: selectorsByType.quote[orderType].getQuote(state),
        isRecurring: orderSelectors.getIsRecurringOrder(state),
        orderType,
      };
    },
    {
      onSubmit: orderActions.submitQuote,
    }
  ),
  withProps(
    ({ t, quote, isFetching, isSubmitting, error, onSubmit, isRecurring }) => {
      const isDataReady = !isEmpty(quote);
      let basePrice = 0;
      let priceConcepts = [];
      let recurringOrderPriceConcepts = [];
      let spotOrderPriceConcepts = [];
      let moreThanOneDayQuote = false;
      let totalPrice = 0;
      let extras = [];
      if (isDataReady) {
        recurringOrderPriceConcepts = getRecurringPriceConcepts({ quote, t });
        moreThanOneDayQuote = recurringOrderPriceConcepts.length > 1;

        if (recurringOrderPriceConcepts.length === 1) {
          const recurringOrderQuote = Object.entries(quote.pricing_days).filter(
            (q) => !!q[1]
          )[0][1];
          extras = getExtras({
            priceInfo: recurringOrderQuote,
            filterExtras: true,
            t,
          });
          basePrice = Number(
            recurringOrderQuote.price_breakdown?.net_price_without_discounts
          );
          totalPrice = Number(recurringOrderQuote.net_full_price);
        } else {
          extras = getExtras({
            priceInfo: quote,
            filterExtras: true,
            t,
          });
          basePrice = Number(
            quote.price_breakdown?.net_price_without_discounts
          );
          totalPrice = Number(quote.net_full_price);
        }

        spotOrderPriceConcepts = getPriceConcepts({
          basePrice,
          extras,
          t,
          quote,
        });
      }

      if (isRecurring && isDataReady && moreThanOneDayQuote) {
        priceConcepts = recurringOrderPriceConcepts;
        totalPrice = Math.min(...priceConcepts.map((p) => p.conceptQuantity));
      } else if (isDataReady) {
        priceConcepts = spotOrderPriceConcepts;
      }

      return {
        hasError: error,
        isFetching,
        isSubmitting,
        isDataReady,
        vatPrice: Number(quote.vat_full_price),
        totalPrice,
        fullPrice: Number(quote.gross_full_price),
        onSubmit: !error ? onSubmit : () => ({}),
        quote: quote,
        priceConcepts,
        moreThanOneDayQuote,
      };
    }
  )
);

const QuotePrice = enhanceWithQuote(QuotePriceStyled);

export { QuotePrice };
